import client from '@/api/client';

export const ZIP_FIND_START = 'zip/find/START';
export const ZIP_FIND_SUCCESS = 'zip/find/SUCCESS';
export const ZIP_FIND_FAILURE = 'zip/find/FAILURE';

export default {
  namespaced: true,
  state: {
    error: null,
    loading: true,
    result: {},
  },
  actions: {
    find({ commit }, payload) {
      commit(ZIP_FIND_START);

      return client
        .get('/zip_search', {
          params: {
            zip: payload.zip.trim(),
          },
        })
        .then(response => commit(ZIP_FIND_SUCCESS, response))
        .catch(error => commit(ZIP_FIND_FAILURE, error));
    },
  },
  mutations: {
    [ZIP_FIND_START](state) {
      state.error = null;
      state.loading = true;
      state.result = {};
    },
    [ZIP_FIND_SUCCESS](state, response) {
      const result = response.data;

      state.error = null;
      state.loading = false;
      state.result = result;
    },
    [ZIP_FIND_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.error = details;
      state.loading = false;
      state.result = {};
    },
  },
};
